import styled, { css } from 'styled-components';
import { Box } from '../Box/Box.js';

const Wrapper = styled(Box)(({ variation, theme }) => css `
    display: flex;
    flex: 1 0 0;
    align-items: flex-start;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    padding: ${theme.olist.spacing.inset.small};
    gap: ${theme.olist.spacing.inline['2xsmall']};
    border-radius: ${theme.olist.borderRadius.small};
    font-size: ${theme.olist.fontSize['1xsmall']};
    background-color: ${theme.olist.components.alert.variation[variation]
    .background};
  `);
const Title = styled.p(({ variation, theme }) => css `
    justify-self: center;
    color: ${theme.olist.components.alert.variation[variation].color};
    font-weight: 600;
  `);
const Description = styled.p(({ variation, theme }) => css `
    align-items: flex-start;
    color: ${theme.olist.components.alert.variation[variation].color};
    font-size: ${theme.olist.fontSize['3xsmall']};
  `);
const CloseIcon = styled.div(({ theme }) => css `
    cursor: pointer;
    color: ${theme.olist.color.neutral.base};

    &:hover {
      color: ${theme.olist.color.neutral.strong};
    }
  `);
const Icon = styled(Box)(({ variation, theme }) => css `
    align-self: flex-start;
    color: ${theme.olist.components.alert.variation[variation].color};
  `);

export { CloseIcon, Description, Icon, Title, Wrapper };
